import { Wallet, Receipt, CreditCard, MessageSquareText, Sparkles } from "lucide-react";
import { useT } from "../../lib/i18n";

export const ComingSoonSection = () => {
    const t = useT();
    const modules = [
        {
            icon: Wallet,
            name: t("PAYCHEY", "PAYCHEY"),
            desc: t(
                "Recharge wallet for distributors and retailers — instant top-ups, transaction history, and reconciled accounting.",
                "డిస్ట్రిబ్యూటర్‌లు మరియు రిటైలర్‌ల కోసం రీఛార్జ్ వాలెట్ — తక్షణ టాప్-అప్, లావాదేవీల చరిత్ర, మరియు అకౌంటింగ్ రికాన్సిలియేషన్."
            ),
            accent: "#FF5A00",
        },
        {
            icon: Receipt,
            name: t("BBPS Bill Payments", "BBPS బిల్ చెల్లింపులు"),
            desc: t(
                "Bharat BillPay integration for electricity, gas, water and DTH — one counter for every household bill.",
                "విద్యుత్, గ్యాస్, నీరు మరియు DTH కోసం భారత్ BillPay ఇంటిగ్రేషన్ — ప్రతి ఇంటి బిల్లుకు ఒకే కౌంటర్."
            ),
            accent: "#FFB200",
        },
        {
            icon: CreditCard,
            name: t("Payment Gateway", "పేమెంట్ గేట్‌వే"),
            desc: t(
                "UPI, cards and net-banking checkout for online recharges — secure, instant, and always available.",
                "ఆన్‌లైన్ రీఛార్జ్‌ల కోసం UPI, కార్డులు మరియు నెట్-బ్యాంకింగ్ చెక్‌అవుట్ — సురక్షితం, తక్షణం, ఎప్పుడూ అందుబాటులో."
            ),
            accent: "#FF5A00",
        },
        {
            icon: MessageSquareText,
            name: t("WhatsApp Business API", "వాట్సాప్ బిజినెస్ API"),
            desc: t(
                "Automated recharge reminders, ticketing and broadcast updates direct from RVS Electronics on WhatsApp.",
                "RVS ఎలక్ట్రానిక్స్ నుండి నేరుగా వాట్సాప్‌లో ఆటోమేటెడ్ రీఛార్జ్ రిమైండర్‌లు, టికెటింగ్ మరియు బ్రాడ్‌కాస్ట్ అప్‌డేట్‌లు."
            ),
            accent: "#FFB200",
        },
    ];

    return (
        <section className="bg-[#0B192C] text-white relative overflow-hidden grid-bg" data-testid="coming-soon-section">
            <div className="absolute -top-40 -left-40 w-[480px] h-[480px] rounded-full bg-[#FF5A00] opacity-20 blur-[120px]" aria-hidden></div>
            <div className="absolute -bottom-40 -right-40 w-[480px] h-[480px] rounded-full bg-[#1E2A3B] opacity-60 blur-[120px]" aria-hidden></div>

            <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-32">
                <div className="flex items-center gap-3 mb-5">
                    <Sparkles className="w-4 h-4 text-[#FF5A00]" />
                    <p className="eyebrow text-[#FF5A00]">{t("Roadmap · Coming Soon", "రోడ్‌మ్యాప్ · త్వరలో")}</p>
                </div>
                <h2 style={{fontFamily: "'Outfit', 'Noto Sans Telugu', sans-serif"}} className="text-3xl sm:text-4xl md:text-5xl font-black tracking-tighter text-white max-w-3xl leading-[1.1]">
                    {t("From a DTH counter to a full digital service hub.", "DTH కౌంటర్ నుండి సంపూర్ణ డిజిటల్ సేవా కేంద్రం వరకు.")}
                </h2>
                <p className="mt-5 text-base md:text-lg text-white/60 max-w-2xl leading-relaxed">
                    {t(
                        "We are building the next generation of services for our customers and retail network. Here's what's launching soon.",
                        "మేము మా కస్టమర్లు మరియు రిటైల్ నెట్‌వర్క్ కోసం తదుపరి తరం సేవలను నిర్మిస్తున్నాము. త్వరలో ప్రారంభమయ్యేవి ఇవే."
                    )}
                </p>

                <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5">
                    {modules.map((m, i) => {
                        const Icon = m.icon;
                        return (
                            <div
                                key={i}
                                data-testid={`coming-soon-${i}`}
                                className="group relative bg-white/[0.03] border border-white/10 rounded-2xl p-7 md:p-9 hover:bg-white/[0.06] transition-colors fade-up"
                                style={{ animationDelay: `${i * 100}ms` }}
                            >
                                <div className="flex items-start justify-between gap-4">
                                    <div
                                        className="w-12 h-12 rounded-xl flex items-center justify-center"
                                        style={{ background: `${m.accent}1f`, color: m.accent }}
                                    >
                                        <Icon className="w-6 h-6" />
                                    </div>
                                    <span className="text-[10px] font-bold tracking-[0.2em] uppercase text-white/50 px-2.5 py-1 border border-white/15 rounded-full">
                                        {t("Coming Soon", "త్వరలో")}
                                    </span>
                                </div>
                                <h3 style={{fontFamily: "'Outfit', 'Noto Sans Telugu', sans-serif"}} className="mt-6 text-2xl font-bold text-white tracking-tight">
                                    {m.name}
                                </h3>
                                <p className="mt-3 text-sm text-white/65 leading-relaxed">{m.desc}</p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
